import React, { useEffect, useState } from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import {
  AppBar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  Toolbar,
  Typography,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import styles from './styles';
import SpecificDataRow from './SpecificDataRow';
import { getEntities as getCalibrationProfiles } from '../../../redux/actions/calibrationProfilesActions';
import { getEntities as getRestaurantZones } from '../../../redux/actions/restautantZones';
import { EditEquipment } from '../../../redux/actions/equipment-specificActions';
import { snackbarShowMessage } from '../../../redux/actions/snackbarActions';
import { useTranslation } from 'react-i18next';

const EquipmentEditSpecificData = ({
  open,
  handleClose,
  restaurantId,
  handleRefreshOnCreate,
  pieceToEdit,
}) => {
  const classes = styles();
  const dispatch: any = useDispatch();
  const { selectedLanguage } = useSelector(
    (state: RootStateOrAny) => state.AppReducer.selectedLanguage,
  );
  const zones = useSelector(
    (state: RootStateOrAny) => state.RestaurantZonesReducer.entities,
  );
  const calibrationProfiles = useSelector(
    (state: RootStateOrAny) => state.CalibrationProfilesReducer.entities,
  );
  const [piece, setPiece] = useState<any>({
    ...pieceToEdit,
    restaurant_zone_id: pieceToEdit.restaurant_zone?.id,
  });
  const selectedBrand = useSelector(
    (state: RootStateOrAny) => state.UIReducer.selectedBrand,
  );

  useEffect(() => {
    if (open && selectedBrand) {
      dispatch(getRestaurantZones(selectedBrand));
      if (selectedBrand === 'TH') {
        dispatch(getCalibrationProfiles(restaurantId));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, selectedBrand]);

  const handleChangeTextFields = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const [name, index] = event.target.name.split('-');
    setPiece({ ...piece, [name]: event.target.value });
  };
  const handleChangeSelect = (
    event: React.ChangeEvent<{ value: unknown; name: string }>,
  ) => {
    const [name, index] = event.target.name.split('-');
    setPiece({ ...piece, [name]: event.target.value });
  };

  const handleChangeDateFields = (
    fieldName, value
  ) => {
    const [name, index] = fieldName.split('-');
    setPiece({ ...piece, [name]: value });
  };

  const clearData = () => {
    handleClose();
    setPiece({
      serial_number: '',
      alternate_name: '',
      restaurant_zone_id: 0,
      equipment_restaurant_id: 0,
      calibration_profile: null,
      equipment_purchase_date: null
    });
  };

  const saveEquipmentPieces = async () => {
    const pieceToUpdate = {
      serial_number: piece.serial_number,
      alternate_name: piece.alternate_name,
      restaurant_zone_id: piece.restaurant_zone_id,
      equipment_restaurant_id: piece.equipment_restaurant[0].id,
      equipment_purchase_date: piece.equipment_purchase_date
    };
    if (selectedBrand === 'TH' && !!piece.calibration_profile) {
      pieceToUpdate['calibration_profile'] = piece.calibration_profile;
    }
    const response: any = await dispatch(
      EditEquipment(piece.equipmentPieceId, pieceToUpdate),
    );
    clearData();
    if (response?.status === 200) {
      dispatch(snackbarShowMessage(SpecificDataStrings.edit_success));
    } else {
      dispatch(snackbarShowMessage(SpecificDataStrings.edit_error));
    }
    handleRefreshOnCreate();
  };

  const { t } = useTranslation();

  const SpecificDataStrings = {
    edit_success: 'equipment.editSuccess',
    edit_error: 'equipment.editError',
    edit_title: t('equipment.editTitle'),
    equipment: t('equipment.equipment'),
    no_available: t('equipment.noAvailable'),
    select_options: t('equipment.selectOptions'),
    create_edit_success: t('equipment.createEditSuccess'),
    create_edit_error: t('equipment.createEditError'),
    create_title: t('equipment.createTitle'),
    category: t('equipment.category'),
    supplier: t('equipment.supplier'),
    model: t('equipment.model'),
    search: t('app.common.search'),
    add_more: t('equipment.addMore'),
    cancel: t('app.common.cancel'),
    save: t('app.common.save'),
  };

  return (
    <Dialog
      fullWidth
      maxWidth="lg"
      open={open}
      onClose={clearData}
      aria-labelledby="max-width-dialog-title"
      disableBackdropClick={true}
      disableEscapeKeyDown={true}
    >
      <DialogContent>
        <DialogTitle id="alert-dialog-title">
          <div className={classes.flexSpaceBetween}>
            <Typography variant="h6">
              {SpecificDataStrings.edit_title}
            </Typography>
            <IconButton
              style={{ position: 'relative', left: '40px' }}
              onClick={clearData}
            >
              <CloseIcon />
            </IconButton>
          </div>
        </DialogTitle>
        <div>
          <AppBar position="static">
            <Toolbar variant="dense" className={classes.flexSpaceBetween}>
              <Typography>{SpecificDataStrings.equipment}</Typography>
            </Toolbar>
          </AppBar>
          <Paper>
            <div>
              <SpecificDataRow
                selectedLanguage={selectedLanguage ||
                  localStorage.getItem('selectedLanguage') || 'eng'}
                brand={selectedBrand}
                index={0}
                piece={piece}
                handleChangeSelect={handleChangeSelect}
                handleChangeTextField={handleChangeTextFields}
                handleChangeDateField={handleChangeDateFields}
                removeRow={() => {}}
                calibrationProfiles={calibrationProfiles}
                zones={zones}
                removeOption={false}
              />
            </div>
          </Paper>
        </div>
      </DialogContent>
      <DialogActions>
        <Button 
          data-testid="clear-button" 
          onClick={clearData} 
          color="primary">
          {SpecificDataStrings.cancel}
        </Button>
        <Button
          onClick={saveEquipmentPieces}
          color="primary"
          data-testid="save-button"
          disabled={
            !piece.alternate_name ||
            !piece.restaurant_zone_id ||            
            piece.alternate_name.length > 100      
          }
        >
          {SpecificDataStrings.save}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EquipmentEditSpecificData;
